button:global(.ant-btn).commentButton {
  width: initial;
  padding: 4px;
  border-radius: 8px;

  display: flex;
  justify-content: space-between;
  gap: 4px;
  align-items: center;

  color: var(--bc-color-text);

  span:global(.ant-btn-icon) {
    margin: 0;
    color: var(--bc-color-text);
  }

  svg {
    color: var(--bc-color-text-quaternary);
  }

  &:not(:disabled) {
    &:hover {
      color: var(--bc-color-text);
      background-color: var(--bc-color-border-secondary) !important;
      svg {
        color: var(--bc-color-primary-active);
      }
    }
  }

  .commentCountText {
    color: var(--bc-color-text);
    text-align: right;
    font-family: var(--bc-font-family);

    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
  }
}
